var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documentTypes.length != 0)?_c('input-document',{staticClass:"input-document",attrs:{"clear-input-on-toggle":"","document-type":_vm.documentTypes,"placeholder":_vm.$gettext('Multi-criteria search')},on:{"add":function($event){return _vm.$emit('add', arguments[0])}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }